export default __webpack_public_path__ + "static/media/basiercircle-regular-webfont.75ed1573.woff2";